module.exports = __webpack_public_path__ + "img/convex2.98e8a2ff.svg";